import React, { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { pb } from '../../../shared/api/pocketbase';
import { fetchCurrentTheme, THEME_VAR_KEYS } from '../../../entities/theme';
import type { ThemeData } from '../../../entities/theme';

const applyTheme = (data: ThemeData | null) => {
  const root = document.documentElement;
  for (const key of THEME_VAR_KEYS) {
    if (data?.[key]) {
      root.style.setProperty(key, data[key]);
    } else {
      root.style.removeProperty(key);
    }
  }
};

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const queryClient = useQueryClient();

  const { data: theme } = useQuery({
    queryKey: ['theme', 'current'],
    queryFn: fetchCurrentTheme,
    staleTime: 60_000,
  });

  useEffect(() => {
    applyTheme(theme?.data ?? null);
  }, [theme]);

  useEffect(() => {
    let unsub: (() => void) | undefined;
    pb.collection('themes').subscribe('*', () => {
      queryClient.invalidateQueries({ queryKey: ['theme', 'current'] });
    }).then(u => { unsub = u; }).catch(() => {});
    return () => { unsub?.(); };
  }, [queryClient]);

  return <>{children}</>;
};
